import {ComplianceManagerApi} from "../compliance-manager";
import OverridePanel from "../../overrides/override-panel";
import {Drawer} from "antd";
import useBreakpoints from "../../../../hooks/useBreakpoints";

export interface OverridePanelDrawerProps {
    api: ComplianceManagerApi
}

export default function OverridePanelDrawer(props: OverridePanelDrawerProps){
    const { api } = props;

    const bp = useBreakpoints();

    const width = bp.max('medium') ? '100%' : 600;

    return <Drawer
        title="Compliance Override"
        visible={api.state.drawers.overridePanel.visible}
        closable
        onClose={() => api.setDrawerVisibility('overridePanel', false)}
        width={width}
    >
        <OverridePanel api={api} />
    </Drawer>
}